<template>
   <div class="crud-wrapper">
      <crud :form-component="RequestForm" :grid-columns="gridColumns" :gridSettings="{noNew: true}"
            :grid-options="gridOptions" obj="request" :key="reRender">
      </crud>
   </div>
</template>

<script>
    import numeral from 'numeral';
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
    import RequestForm from './RequestForm';

    export default PageClass.extend({
        name: 'Requests',

        data() {
            return {
                RequestForm,
                reRender: 0,
                gridColumns: null,
                gridOptions: {},
                dataFilter: {},
            
                gridColumns: [
                    {
                        dataField: 'personName',
                        caption: 'Nome',
                        minWidth: 120
                    },
                    {
                        dataField: 'personCity',
                        caption: 'Cidade',
                        minWidth: 120
                    },
                    {
                        dataField: 'personState',
                        caption: 'Estado',
                        minWidth: 120
                    },
                    {
                        dataField: 'productName',
                        caption: 'Produto',
                        minWidth: 120
                    },
                    {
                        dataField: 'createdAt',
                        caption: 'Solicitado em',
                        dataType: "date",
                        format: 'dd/MM/yyyy hh:mm',
                    }
                ]
            };
        },
    });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Requests.vue